import {
  DEFAULT_LANGUAGE,
  PRIORITY_LANGUAGES,
  priorityLanguageMap,
} from "src/config/languages";

// Inputting a language code like "en" or "fr" returns the full language object
// Default return value: priorityLanguageMap["en"]
const getLocale = (lang: keyof typeof priorityLanguageMap) => {
  const language = PRIORITY_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
  return priorityLanguageMap[language];
};

// Inputting a language string like "English" returns the code "en"
// Default return value: "en"
const getLanguageCode = (lang: string | null | undefined): string => {
  if (!lang) return DEFAULT_LANGUAGE;

  return (
    Object.keys(priorityLanguageMap).find(
      (key) =>
        priorityLanguageMap[key as keyof typeof priorityLanguageMap].value ===
        lang
    ) ?? DEFAULT_LANGUAGE
  );
};

export { getLocale, getLanguageCode };
